import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Box, Typography, Button, Chip, Paper } from '@mui/material';
export var HomeCard = function (_a) {
    var Icon = _a.icon, image = _a.image, title = _a.title, description = _a.description, chips = _a.chips, onClick = _a.onClick;
    return (_jsxs(Paper, { elevation: 3, sx: {
            padding: 3,
            textAlign: 'center',
            marginBottom: 3,
            height: '100%',
        }, children: [_jsx(Box, { display: "flex", justifyContent: "center", mb: 2, children: image ? (_jsx(Box, { component: "img", src: image, alt: title, sx: {
                        width: '50%',
                        height: '100%',
                    } })) : (Icon && _jsx(Icon, { fontSize: "large", sx: { color: '#1976d2' } })) }), _jsx(Typography, { variant: "h6", gutterBottom: true, children: title }), _jsx(Typography, { variant: "body2", color: "textSecondary", children: description }), _jsx(Box, { mb: 2, children: chips.map(function (chip, index) { return (_jsx(Chip, { label: chip, sx: { margin: 0.5 } }, index)); }) }), _jsx(Button, { variant: "text", color: "primary", fullWidth: true, onClick: onClick, children: "ACESSAR" })] }));
};
